$(function () {

    // Add class if edge
    if (/Edge/.test(navigator.userAgent)) {
        $('body').addClass('ie ie--edge');
    }

    // Add class if IE 11
    var is_ie11 = navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > -1;
    if (is_ie11) {
        $('body').addClass('ie ie--11');
    }

    // Add class if IE10
    var is_ie10 = navigator.appVersion.indexOf("MSIE 10") !== -1;
    if (is_ie10) {
        $('body').addClass('ie ie--10');
    }

    // Add class if safari
    var is_safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (is_safari) {
        $('body').addClass('body--safari');
    }

    // Remove empty paragraphs
    $('p').filter(function(){ return $.trim(this.innerHTML)==="&nbsp;" }).remove();

    /* ==== init ==== */
    $('.lazy-load').Lazy({
        effect: 'fadeIn',
        effectTime: 300
    });

    /* === Add aria labels to owl carousel buttons === */
    $('.owl-carousel').each(function() {
        //Find each set of dots in this carousel
        $(this).find('.owl-dot').each(function(index) {
            //Add one to index so it starts from 1
            $(this).attr('aria-label', index + 1);
        });
    });


    /* === Custom bullet list === */
    $('.list-item--custom').closest('ul').addClass('ul--stripped');


    //$('.map-panel').lazyLoadGoogleMaps();


    /* ==== Cookie notice ==== */
    var cookie = $('.cookie-notice');

    if (Cookies.get('fableCookie')) {
        cookie.hide();
    } else {
        cookie.show();
        $('.cookie-notice__close').click(function () {
            Cookies.set('fableCookie', 'accepted', {
                expires: 365
            });
            cookie.hide();
        });
    }
}); 
  $('a[href*="#"]')
        // Remove links that don't actually link to anything
        .not('[href="#"]')
        .not('[href="#0"]')
        .click(function (event) { 
            // On-page links
            if (
                location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
                &&
                location.hostname == this.hostname
            ) {
                // Figure out element to scroll to
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                // Does a scroll target exist?
                if (target.length) {
                    // Only prevent default if animation is actually gonna happen
                    event.preventDefault();
                    $('html, body').animate({
                        scrollTop: target.offset().top
                    }, 1000, function () {
                        // Callback after animation
                        // Must change focus!
                        var $target = $(target);
                        $target.focus();
                        if ($target.is(":focus")) { // Checking if the target was focused
                            return false;
                        } else {
                            $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                            $target.focus(); // Set focus again
                        };
                    });
                }
            }
        });
$(".chapter-panel").mouseenter(function () {
    var rollover = $(this).find('.chapter-panel__rollover');
    rollover.css("opacity", "1");
});
$(".chapter-panel").mouseleave(function () {
    var rollover = $(this).find('.chapter-panel__rollover');
    rollover.css("opacity", "0");
});

// $(window).on('load', function () {

//     // Remove loading window
//     setTimeout(function () {
//         $('.loading-overlay').addClass('loading-overlay--hide');
//         $('.homepage').addClass('homepage--active');
//         $('main').addClass('main--active');

//         // Re-run the polyfill on multiple elements
//         var elements = document.querySelectorAll('.main-banner__img');
//         objectFitPolyfill(elements);

//         elements2 = document.querySelectorAll('.panel__image');
//         objectFitPolyfill(elements2);

//     }, 500);

// });


function owl_Carousel_Init(element, childElements, autoSlide_user, autoplayTimeout_user) {

    if (element === null || typeof element === 'undefined' || element === '') {
        alert('You need to specify an element for the owl carousel slider to attach to'); 
    }
    if (childElements === null || typeof childElements === 'undefined' || childElements === '') {
        alert('You need to specify the slide elements for the owl carousel slider to attach to');
    }
    if (autoplayTimeout_user === null || typeof autoplayTimeout_user === 'undefined' || autoplayTimeout_user === '') {
        autoplayTimeout_user = 5000;
    }

    var bannerSlide = $(element);

    bannerSlide.each(function (i) {
        $(this).attr('id', i + 1);
        var item_count = parseInt($(this).find(childElements).length);  // '.main-banner__slide'
        var true_false = false;
        if (item_count > 1) {
            true_false = true;
        } else {
            true_false = false;
        }
        var autoSlide = true_false;

        if (true_false === true) {
            // Only do this check if true. Don't want to be setting auto scroll if only one element
            autoSlide = autoSlide_user;
        } else {
            autoSlide = false;
        }

        var owl = $(this).owlCarousel({
            items: 1,
            margin: 0,
            loop: true,
            dots: true,
            nav: true,
            navText: ['<img src="/img/icons/PrevArrow.svg">', '<img src="/img/icons/NextArrow.svg">'],
            touchDrag: true_false,
            mouseDrag: true_false,
            lazyLoad: true,
            autoplay: autoSlide,
            autoplayTimeout: autoplayTimeout_user
        });

        owl.on('changed.owl.carousel', function (e) {
            owl.trigger('stop.owl.autoplay');
            owl.trigger('play.owl.autoplay');
        });
    });
}
function owl_Carousel_Init_Related(element, childElements, autoSlide_user, autoplayTimeout_user) {
    var navImageSuffix = '';
    if ($('body').hasClass('farFromOrdinary')) {
        navImageSuffix = '--white';
    }

    if (element === null || typeof element === 'undefined' || element === '') {
        alert('You need to specify an element for the owl carousel slider to attach to');
    }
    if (childElements === null || typeof childElements === 'undefined' || childElements === '') {
        alert('You need to specify the slide elements for the owl carousel slider to attach to');
    }
    if (autoplayTimeout_user === null || typeof autoplayTimeout_user === 'undefined' || autoplayTimeout_user === '') {
        autoplayTimeout_user = 5000;
    }

    var bannerSlide = $(element);

    bannerSlide.each(function (i) {
        $(this).attr('id', i + 1);
        var item_count = parseInt($(this).find(childElements).length);  // '.main-banner__slide'
        var true_false = false;
        if (item_count > 1) {
            true_false = true;
        } else {
            true_false = false;
        }
        var autoSlide = true_false;

        if (true_false === true) {
            // Only do this check if true. Don't want to be setting auto scroll if only one element
            autoSlide = autoSlide_user;
        } else {
            autoSlide = false;
        }

        var owl = $(this).owlCarousel({
            items: 4,
            margin: 0,
            loop: true,
            dots: true,
            nav: true,
            navText: ['<img src="/img/icons/PrevArrow' + navImageSuffix + '.svg">', '<img src="/img/icons/NextArrow' + navImageSuffix +'.svg">'],
            responsiveClass: true,
            responsive: {
                0: {
                    items: 1,
                    nav: false
                },
                600: {
                    items: 2,
                    nav: false
                },
                1000: {
                    items: 4,
                    nav: true,
                    loop: false
                }
            },
            touchDrag: true_false,
            mouseDrag: true_false,
            lazyLoad: true,
            autoplay: false
            
        });

        owl.on('changed.owl.carousel', function (e) {
            owl.trigger('stop.owl.autoplay');
            owl.trigger('play.owl.autoplay');
        });
    });
}